import axios from 'axios';
import { loginreq, req,exportFile } from './axiosFun';
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
/**
 * 二维码订单管理
 **/
// 待合成
export const waitComposeList = (params) => { return req("post", "/api/orderlist/waitcompost", params) };
// 待发货
export const WaitDelivery = (params) => { return req("post", "/api/file/getFilesList", params) };

// 已发货
//export const Deliverid = (params) => { return req("post", "/api/orders/file/getFilesListdelive", params) };
//export const Deliverid = (params) => { return req("post", "/api/orderlist/deliverid", params) };
export const Deliverid = (params) => { return req("post", "/api/file/getFilesListdelive", params) };
// 发货
export const delivery = (params) => { return req("post", "/api/orderlist/deliveryByPDF", params) };

// 按sn查询
export const getOrderBySn = (params) => { return req("post", "/api/orderlist/getOrderBySN", params) };
export const getOrdersBySn = (params) => { return req("post", "/api/orderlist/getOrdersBySN", params) };

//需要补码记录
export const getneedbumalist = (params) => { return req("post", "/api/orderlist/getneedbumalist", params) };
// 补码
export const buma = (params) => { return req("post", "/api/BUMA", params) };
//删除待补码数据
export const needbumadel = (params) => { return req("post", "/api/orderlist/needbumadel", params) };


//手工合成
export const compose = (params) => { return req("post", "/api/compose", params) };
// 数据面板
export const query = (params) => { return req("post", "/api/count/query", params) };


// 取消发货
export const nodelivery = (params) => { return req("post", "/api/orderlist/nodelivery", params) };

// 数据面板查询历史数据
export const queryByDate = (params) => { return req("post", "/api/count/queryByDate", params) };

// 补码记录
export const Buma = (params) => { return req("post", "/api/buma/getBumaList", params) };

// 打印标签
export const createExcel = (params) => { return req("post", "/api/label/createExcel") };

export const createLableFile = (params) => { return req("post", "/api/label/createLableFile", params) };

//手工合成一个标签
export const printlabelone = (params) => { return req("post", "/api/label/createLableone", params) };

//重新合成
export const againCompose = (params) => { return req("post", "/api/againCompose", params) };
//物料信息
export const getOrderListAll = (params) => { return req("post", "/api/orderlist/getOrderListAll", params) };
// 导出excel

export const exportExcel = (params) => { return exportFile("post", "/api/export", params) };
//删除物料
export const del = (params) => { return req("post", "/api/orderlist/del", params) };






// WEBPACK FOOTER //
// ./src/api/ordersMG.js